module.exports = __webpack_public_path__ + "media/images/components/landing_pages/reassurance_cards/flexible-c4493a6cc60b27f21acff3d596eff06e.png";